import React, { useState, useEffect } from "react";
import {
  Drawer,
  Image,
  Select,
  Input,
  DatePicker,
  Checkbox,
  Row,
  Col,
  Form,
  message,
  Button,
} from "antd";
import "../styles/BuilderPersonalInfo.css";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { updateWorker } from "../../getDatabase";
import { useRequest } from "ahooks";
import {
  BuilderHeader,
  compressImage,
  currencyFormatKHR,
  LabelInputFormModal,
  UploadController,
} from "../../own-comp";
import moment from "moment";
import {
  postionOption,
  skillOption,
  workStatusOption,
} from "../../constant/builder";

const { Option } = Select;
const { TextArea } = Input;
function UpdateWorker({ open, setOpen, refresh, data }) {
  const [form] = Form.useForm();
  const [imageFild, setImageFild] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [feeData, setFeeData] = useState([]);

  const { run, loading } = useRequest(updateWorker, {
    manual: true,
    onSuccess: () => {
      setOpen(false);
      message.success("រក្សាទុកជោគជ័យ!!");
      refresh();
    },
  });
  const handleResize = () => {
    // 960
    if (window.innerWidth <= 960) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    handleResize();
  }, []);
  window.addEventListener("resize", handleResize);

  const onClose = () => {
    setOpen(false);
  };

  const onSelectStartImage = async (e) => {
    let imageFile = e.target.files[0];
    if (imageFile?.type?.split("/")[0] === "image") {
      setImageFild(await compressImage(imageFile));
    } else {
      message.error("មិនមែនជា File រូបភាពទេ!!");
    }
  };
  useEffect(() => {
    setImageFild(null);
    if (data) {
      const fees = data?.fees.map((element) => ({
        date: element.date !== "0000-00-00" ? moment(element.date) : null,
        fee: element.fee,
        remark: element.remark,
        wf_id: element?.wf_id,
      }));

      setFeeData(fees);

      form.setFieldsValue({
        ...data,
        join_price: fees[0]?.fee,
        current_price: fees?.length > 0 ? fees[fees?.length - 1]?.fee : null,
        join_date:
          data?.join_date !== "0000-00-00" ? moment(data?.join_date) : null,
        end_date:
          data?.end_date !== "0000-00-00" ? moment(data?.end_date) : null,
        fee: fees,
        skills: data?.skills ? [...data?.skills] : [],
      });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [data]);

  const setToSkillFn = (value) => {
    form.setFieldValue({
      skills: value,
    });
  };

  const onFinish = async (values) => {
    run({ data: { ...values, id: data?.w_id }, imageFile: imageFild });
  };

  return (
    <>
      <Drawer
        width={isMobile ? "100%" : 750}
        title={<b>កែប្រែជាង</b>}
        placement="right"
        onClose={onClose}
        open={open}
      >
        <Form form={form} onFinish={onFinish}>
          <Row>
            <Col
              xs={24}
              sm={24}
              md={10}
              lg={10}
              xl={10}
              style={{ padding: 10 }}
            >
              {imageFild !== null ? (
                <Image
                  style={{
                    objectFit: "contain",
                    backgroundColor: "#cccccc",
                  }}
                  width={"100%"}
                  height={350}
                  src={URL.createObjectURL(imageFild)}
                />
              ) : (
                <Image
                  style={{
                    objectFit: "contain",
                    backgroundColor: "#cccccc",
                  }}
                  width={"100%"}
                  height={350}
                  src={
                    data?.worker_image !== ""
                      ? `${process.env.React_App_WORKER_PROFILE}/${data?.worker_image}`
                      : "error"
                  }
                  fallback="data:image/png;base64,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"
                />
              )}
              <UploadController
                name="editBuilderImage"
                accept="image/png, image/jpeg, image/jpg"
                // value={resultImage}
                onChange={onSelectStartImage}
              >
                <div>Upload/Change</div>
              </UploadController>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={{ span: 14, offset: 0 }}
              lg={{ span: 14, offset: 0 }}
              xl={{ span: 14, offset: 0 }}
              style={{ padding: 10 }}
            >
              <LabelInputFormModal
                title={`លេខកូដ`}
                form={
                  <Form.Item
                    name="worker_full_id"
                    rules={[
                      {
                        required: true,
                        message: "ត្រូវការ",
                      },
                    ]}
                  >
                    <Input
                      autoComplete="new-password"
                      style={{ width: "100%" }}
                      size="large"
                      placeholder="លេខកូដ (ស្វ័យប្រវត្ត)"
                      disabled
                    />
                  </Form.Item>
                }
              />

              <LabelInputFormModal
                title={`អត្តសញ្ញាណបណ្ណ`}
                form={
                  <Form.Item name="id_card_number">
                    <Input
                      autoComplete="new-password"
                      style={{ width: "100%" }}
                      size="large"
                      placeholder="xxx xxx xxx"
                    />
                  </Form.Item>
                }
              />

              <LabelInputFormModal
                title={`ឈ្មោះ`}
                form={
                  <Form.Item
                    name="full_name"
                    rules={[
                      {
                        required: true,
                        message: "ត្រូវការ",
                      },
                    ]}
                  >
                    <Input
                      autoComplete="new-password"
                      style={{ width: "100%" }}
                      size="large"
                      placeholder="ឈ្មោះ"
                    />
                  </Form.Item>
                }
              />

              <LabelInputFormModal
                title={`តួនាទី`}
                form={
                  <Form.Item
                    name="position"
                    rules={[
                      {
                        required: true,
                        message: "ត្រូវការ",
                      },
                    ]}
                  >
                    <Select
                      placeholder="ប្រភេទ"
                      style={{ width: "100%" }}
                      size="large"
                    >
                      {postionOption?.map((e) => (
                        <Option key={e} value={e}>
                          {e}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                }
              />

              <LabelInputFormModal
                title={`Tel`}
                form={
                  <Form.Item name="phone_number">
                    <Input
                      autoComplete="new-password"
                      style={{ width: "100%" }}
                      size="large"
                      placeholder="Tel"
                    />
                  </Form.Item>
                }
              />
              <LabelInputFormModal
                title={`តម្លៃចូល`}
                form={
                  <Form.Item>
                    <div className="disabled-input-display">
                      {feeData?.length > 0
                        ? currencyFormatKHR(feeData[0]?.fee)
                        : "តម្លៃចូល"}
                    </div>
                  </Form.Item>
                }
              />
              <LabelInputFormModal
                title={`តម្លៃបច្ចុប្បន្ន`}
                form={
                  <Form.Item>
                    <div className="disabled-input-display">
                      {feeData?.length > 0
                        ? currencyFormatKHR(feeData[feeData?.length - 1]?.fee)
                        : "តម្លៃបច្ចុប្បន្ន"}
                    </div>
                  </Form.Item>
                }
              />

              <LabelInputFormModal
                title={`ស្ថានភាព`}
                form={
                  <Form.Item
                    name="work_status"
                    rules={[
                      {
                        required: true,
                        message: "ត្រូវការ",
                      },
                    ]}
                  >
                    <Select
                      placeholder="ស្ថានភាព"
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {workStatusOption?.map((e) => (
                        <Option key={e} value={e}>
                          {e}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                }
              />
            </Col>
          </Row>
          {/* worker-skill */}
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="worker-skill"
            >
              <BuilderHeader title={`ជំនាញ`} />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={{ span: 14, offset: 10 }}
              lg={{ span: 12, offset: 12 }}
              xl={{ span: 12, offset: 12 }}
              style={{ padding: 10 }}
            >
              <Form.Item name="skills">
                <Checkbox.Group
                  onChange={setToSkillFn}
                  style={{ width: "100%" }}
                >
                  <Row>
                    {skillOption?.map((e) => (
                      <Col
                        xs={{ span: 8 }}
                        sm={{ span: 8 }}
                        md={{ span: 8 }}
                        lg={{ span: 8 }}
                        xl={{ span: 8 }}
                        style={{ padding: 10 }}
                        key={e}
                      >
                        <Checkbox value={e}>{e}</Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>
          {/* worker-history */}
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="worker-skill"
            >
              <BuilderHeader title={`ប្រវត្តិ`} />

              <div className="worker-history-form">
                <Row gutter={10}>
                  <Col xs={7} sm={7} md={7} lg={7} xl={7}>
                    ថ្ងៃចូលធ្វើការ
                  </Col>
                  <Col
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    style={{ textAlign: "center" }}
                  >
                    :
                  </Col>
                  <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                    <Form.Item
                      name="join_date"
                      rules={[
                        {
                          required: true,
                          message: "ត្រូវការ",
                        },
                      ]}
                    >
                      <DatePicker
                        format={"DD/MM/YYYY"}
                        placeholder="dd/mm/yyyy"
                        style={{ width: "100%" }}
                        size="large"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={7} sm={7} md={7} lg={7} xl={7}>
                    ថ្ងៃឈប់ធ្វើការ
                  </Col>
                  <Col
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    style={{ textAlign: "center" }}
                  >
                    :
                  </Col>
                  <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                    <Form.Item name="end_date">
                      <DatePicker
                        format={"DD/MM/YYYY"}
                        placeholder="dd/mm/yyyy"
                        style={{ width: "100%" }}
                        size="large"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {/* worker-Payrol */}
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              // style={{ padding: 10 }}
            >
              <BuilderHeader title={`ប្រវត្តិប្រាក់ខែ`} />
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ padding: 10, paddingTop: 20 }}
            >
              <Form.List name="fee">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Row gutter={10} className="worker-history-row" key={key}>
                        <Col xs={2} sm={2} md={1} lg={1} xl={1}>
                          {/* className="worker-history-remove" */}
                          <Button
                            onClick={() => remove(name)}
                            size="small"
                            shape="circle"
                            icon={<MinusCircleOutlined />}
                            danger
                            style={{ cursor: "pointer" }}
                          />
                        </Col>
                        <Col xs={10} sm={10} md={6} lg={6} xl={6}>
                          {/* className="worker-history-input-date" */}
                          <Form.Item
                            name={[name, "date"]}
                            rules={[
                              {
                                required: true,
                                message: "ត្រូវការ",
                              },
                            ]}
                          >
                            <DatePicker
                              format={"DD/MM/YYYY"}
                              placeholder="dd/mm/yyyy"
                              style={{ width: "100%" }}
                              size="large"
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          xs={1}
                          sm={1}
                          md={1}
                          lg={1}
                          xl={1}
                          style={{ textAlign: "center" }}
                        >
                          :
                        </Col>
                        <Col xs={11} sm={11} md={6} lg={6} xl={6}>
                          {/* className="worker-history-input-salary" */}
                          <Form.Item
                            name={[name, "fee"]}
                            rules={[
                              {
                                required: true,
                                message: "ត្រូវការ",
                              },
                            ]}
                          >
                            <Input
                              autoComplete="new-password"
                              style={{ width: "100%" }}
                              size="large"
                              placeholder="0000"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={22} sm={22} md={6} lg={6} xl={6}>
                          {/* className="worker-history-input-other" */}
                          <Form.Item name={[name, "remark"]}>
                            <Input
                              autoComplete="new-password"
                              style={{ width: "100%" }}
                              size="large"
                              placeholder="ផ្សេងៗ"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    ))}

                    <div className="add-worker-salary-History">
                      <Button
                        type="primary"
                        style={{ width: "200px" }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        តម្លៃថ្មី
                      </Button>
                    </div>
                  </>
                )}
              </Form.List>
            </Col>
          </Row>

          {/* Personal-Info-other */}
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="worker-skill"
            >
              <BuilderHeader title={`ផ្សេងៗ`} />

              <div className="worker-history-form">
                <Row gutter={10}>
                  <Col xs={7} sm={7} md={7} lg={7} xl={7}>
                    ហ្វេសប៊ុក Link
                  </Col>
                  <Col
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    style={{ textAlign: "center" }}
                  >
                    :
                  </Col>
                  <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                    <Form.Item
                      name="facebook_url"
                      rules={[{ type: "url", message: "URL មិនត្រឹមត្រូវ" }]}
                    >
                      <Input
                        autoComplete="new-password"
                        style={{ width: "100%" }}
                        size="large"
                        placeholder="facebook url"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={7} sm={7} md={7} lg={7} xl={7}>
                    អាស័យដ្ឋាន
                  </Col>
                  <Col
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    style={{ textAlign: "center" }}
                  >
                    :
                  </Col>
                  <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                    <Form.Item name="address">
                      <Input
                        autoComplete="new-password"
                        style={{ width: "100%" }}
                        size="large"
                        placeholder="អាស័យដ្ឋាន"
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={7} sm={7} md={7} lg={7} xl={7}>
                    ផ្សេងៗ
                  </Col>
                  <Col
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    style={{ textAlign: "center" }}
                  >
                    :
                  </Col>
                  <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                    <Form.Item name="remark">
                      <TextArea rows={4} />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="worker-skill"
            >
              <div className="worker-fotter-submit">
                <div className="worker-fotter-submit-container">
                  <Button
                    htmlType="submit"
                    type="primary"
                    style={{ width: "100%" }}
                    loading={loading}
                  >
                    រក្សាទុក
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
}

export default UpdateWorker;
